/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';

import { IPageHeaderData } from './page-header.data';
import { IPageHeaderProps } from './page-header.props.autogenerated';

export interface IPageHeaderViewProps extends IPageHeaderProps<IPageHeaderData> {
    image?: Msdyn365.IImageData;
    title?: string;
    subtitle?: string;
}

/**
 *
 * PageHeader component
 * @extends {React.PureComponent<IPageHeaderProps<IPageHeaderData>>}
 */
class PageHeader extends React.PureComponent<IPageHeaderProps<IPageHeaderData>> {
    public render(): JSX.Element | null {
        const viewProps = {
            ...this.props,
            image: this.props.config.pageImage,
            title: this.props.config.pageTitle,
            subtitle: this.props.config.pageSubtitle
        };
        return this.props.renderView(viewProps);
    }
}

export default PageHeader;
